export interface BuildConfig {
  appEnv: string;
  cartapi: string;
  accounts: string;
  retail: string;
  cartApiKey: string;
  create: string;
  commerce: string;
  catalogproduct: string;
  shopping: string;
  photosbaseurl: string;
  accountsfe: string;
  catalogdesign: string;
  projects: string;
}

export const buildConfig: Record<string, BuildConfig> = {
  dev: {
    appEnv: 'dev',
    cartapi: 'https://cart-api3.dev.shutterfly.com/cart',
    cartApiKey: 'd9ylKEVogc9QtRmDnJyKFgk4DdK8iDG7',
    accounts: 'https://accounts-api3.dev.shutterfly.com/accounts',
    retail: 'https://retail-api3.dev.shutterfly.com/retail-core',
    create: 'https://www3.dev.shutterfly.com/create',
    commerce: 'https://commerce-api3.dev.shutterfly.com/commerce',
    catalogproduct: 'https://catalog-api3.dev.shutterfly.com/catalogproduct',
    shopping: 'https://www3.dev.shutterfly.com',
    photosbaseurl: 'https://photos3.dev.shutterfly.com',
    accountsfe: 'https://accounts.dev.shutterfly.com',
    catalogdesign: 'https://catalog-api3.dev.shutterfly.com/catalogdesign',
    projects: 'https://projects-api3.dev.shutterfly.com/projects',
  },
  stage: {
    appEnv: 'stage',
    cartapi: 'https://cart-api3.stage.shutterfly.com/cart',
    cartApiKey: '6aGAIEelXSZ6AIt1KY7CJIiBCEq7LWy0',
    accounts: 'https://accounts-api3.stage.shutterfly.com/accounts',
    retail: 'https://retail-api3.stage.shutterfly.com/retail-core',
    create: 'https://www.stage.shutterfly.com/create',
    commerce: 'https://commerce-api3.stage.shutterfly.com/commerce',
    catalogproduct: 'https://catalog-api3.stage.shutterfly.com/catalogproduct',
    shopping: 'https://www3.stage.shutterfly.com',
    photosbaseurl: 'https://photos3.stage.shutterfly.com',
    accountsfe: 'https://accounts.stage.shutterfly.com',
    catalogdesign: 'https://catalog-api3.stage.shutterfly.com/catalogdesign',
    projects: 'https://projects-api3.stage.shutterfly.com/projects',
  },
  prod: {
    appEnv: 'prod',
    cartapi: 'https://cart-api3.shutterfly.com/cart',
    cartApiKey: 'zlrHU7h6cTGTApk3IbOU0aVuxlEJkPeA',
    accounts: 'https://accounts-api3.shutterfly.com/accounts',
    retail: 'https://retail-api3.shutterfly.com/retail-core',
    create: 'https://www.shutterfly.com/create',
    commerce: 'https://commerce-api3.shutterfly.com/commerce',
    catalogproduct: 'https://catalog-api3.shutterfly.com/catalogproduct',
    shopping: 'https://www.shutterfly.com',
    photosbaseurl: 'https://photos3.shutterfly.com',
    accountsfe: 'https://accounts.shutterfly.com',
    catalogdesign: 'https://catalog-api3.shutterfly.com/catalogdesign',
    projects: 'https://projects-api3.shutterfly.com/projects',
  },
};

// export const buildConfig: BuildConfig =
//   config[process.env.ENV as keyof typeof config];
